import Vue from 'vue'
import Router from 'vue-router'
import Test from '@/components/common/IconContainer'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login',
      meta: { title: '鑫智造云管家' }
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/views/login'], resolve),
      meta: { title: '登录' }
    },
    {
      path: '/cms',
      name: 'cms',
      component: resolve => require(['@/views/cms'], resolve),
      redirect: '/cms/index',
      meta: { title: '首页' },
      children: [
        {
          path: 'index',
          name: 'cmsindex',
          component: resolve => require(['@/views/index'], resolve),
          meta: { title: '系统首页' }
        },

        // 基础资料
        {
          path: 'basedata/urlmanager',
          name: 'basedata',
          component: resolve => require(['@/views/basedata/urlmanager'], resolve),
          meta: { title: '菜单管理' }
        },
        {
          path: 'basedata/accountmanager',
          name: 'basedata',
          component: resolve => require(['@/views/basedata/accountmanager'], resolve),
          meta: { title: '用户管理' }
        },
        {
          path: 'basedata/rolemanager',
          name: 'basedata',
          component: resolve => require(['@/views/basedata/rolemanager'], resolve),
          meta: { title: '角色管理' }
        },
        {
          path: 'basedata/departmentmanager',
          name: 'basedata',
          component: resolve => require(['@/views/basedata/departmentmanager'], resolve),
          meta: { title: '部门管理' }
        },

        // 云管家
        {
          path: 'cloudcms/customermanager',
          name: 'cloudcms',
          component: resolve => require(['@/views/cloudcms/customermanager'], resolve),
          meta: { title: '客户管理' }
        },
        {
          path: 'cloudcms/projectmanager',
          name: 'cloudcms',
          component: resolve => require(['@/views/cloudcms/projectmanager'], resolve),
          meta: { title: '项目管理' }
        },
        {
          path: 'cloudcms/suggestmanager',
          name: 'cloudsuggest',
          component: resolve => require(['@/views/cloudcms/cloudsuggest'], resolve),
          meta: { title: '项目管理' }
        },
        {
          path: 'cloudcms/cloudmsg',
          name: 'cloudmsg',
          component: resolve => require(['@/views/cloudcms/cloudmessage'], resolve),
          meta: { title: '消息管理' }
        },
        // 任务调度管理
        {
          path: 'taskscheduler/taskmanager',
          name: 'taskmanager',
          component: resolve => require(['@/views/taskscheduler/taskmanager'], resolve),
          meta: { title: '客户管理' }
        },
        {
          path: 'quartz/scheduler',
          name: 'quartzscheduler',
          component: resolve => require(['@/views/taskscheduler/schedulers'], resolve),
          meta: { title: '调度器管理' }
        },
        {
          path: 'quartz/triggers',
          name: 'quartztriggers',
          component: resolve => require(['@/views/taskscheduler/triggers'], resolve),
          meta: { title: '触发器管理' }
        },
        {
          path: 'quartz/jobsdetail',
          name: 'quartzjobsdetail',
          component: resolve => require(['@/views/taskscheduler/taskmanager'], resolve),
          meta: { title: '定时器' }
        }
        // 系统参数 /cms/quartz/scheduler
        // {
        //   path: 'taskscheduler/taskmanager',
        //   name: 'taskmanager',
        //   component: resolve => require(['@/views/taskscheduler/taskmanager'], resolve),
        //   meta: { title: '系统参数' }
        // }
      ]
    }, {
      path: '/test',
      name: 'Test',
      component: Test,
      meta: { title: '测试' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') { next() } else {
    let token = localStorage.getItem('Authorization')
    if (!token) { next('/login') } else { next() }
  }
})

router.afterEach((transition) => {
  // console.log('transition===>', transition)
  document.title = `鑫智造云管家-${transition.meta.title}`
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js